const ErrorIcon = ( { ...props } ) => {
	return (
		<svg
			aria-hidden="true"
			focusable="false"
			data-testid="error-svg"
			role="img"
			width="20"
			height="20"
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{ ...props }
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.78126 3.91278C5.4248 2.24389 7.65857 1.28806 10.0006 1.25152C11.1428 1.22919 12.278 1.43515 13.3396 1.85733C14.4011 2.27951 15.3677 2.9094 16.1826 3.71006C16.9976 4.51072 17.6444 5.46604 18.0853 6.51999C18.5261 7.57395 18.7521 8.70532 18.7499 9.84775C18.7694 12.1883 17.8587 14.4407 16.218 16.1101C14.5774 17.7794 12.3411 18.729 10.0006 18.7502H9.85477C8.72501 18.7521 7.60598 18.5311 6.56176 18.0999C5.51754 17.6687 4.56866 17.0357 3.76946 16.2372C2.97026 15.4386 2.33645 14.4903 1.90433 13.4464C1.47222 12.4026 1.25028 11.2837 1.25124 10.154C1.23365 8.99728 1.44853 7.84882 1.88313 6.77672C2.31773 5.70463 2.9632 4.73073 3.78126 3.91278ZM9.27168 10.3945V6.0198C9.27168 5.82643 9.34849 5.64098 9.48523 5.50424C9.62196 5.36751 9.80741 5.29069 10.0008 5.29069C10.1942 5.29069 10.3796 5.36751 10.5163 5.50424C10.6531 5.64098 10.7299 5.82643 10.7299 6.0198V10.3945C10.7299 10.5879 10.6531 10.7733 10.5163 10.91C10.3796 11.0468 10.1942 11.1236 10.0008 11.1236C9.80741 11.1236 9.62196 11.0468 9.48523 10.91C9.34849 10.7733 9.27168 10.5879 9.27168 10.3945ZM8.90712 13.3109C8.90116 13.1643 8.92515 13.0181 8.97762 12.8811C9.03009 12.7441 9.10995 12.6192 9.21231 12.5141C9.31467 12.4091 9.43739 12.3259 9.57296 12.2699C9.70852 12.2138 9.8541 12.186 10.0008 12.1881C10.288 12.1898 10.5634 12.3021 10.7699 12.5017C10.9763 12.7014 11.0978 12.9729 11.109 13.2599C11.1149 13.4043 11.0916 13.5484 11.0404 13.6835C10.9891 13.8186 10.9111 13.942 10.811 14.0462C10.7109 14.1504 10.5907 14.2333 10.4578 14.2899C10.3248 14.3464 10.1818 14.3756 10.0372 14.3754C9.74751 14.3795 9.46755 14.2707 9.25662 14.072C9.04569 13.8734 8.92035 13.6004 8.90712 13.3109Z"
			></path>
		</svg>
	);
};

export { ErrorIcon };
